import { useEffect, useState, useRef, useCallback } from 'react';
import WrappingContainer from '../../HOC/WrappingContainer/WrappingContainer';
import styles from './ApplicantPage.module.css';
import applicanttabIcon from '../../../assets/Imagess/applicanticon.svg';
import intresetedtabIcon from '../../../assets/Imagess/interestedicon.svg';
import TableTopHeader from '../../Moecules/TableTopHeader/TableTopHeader';
import StatusModal from '../../Moecules/Settings/SettingsModal/StatusModal';
import EmailModal from '../../Moecules/Settings/SettingsModal/EmailModal';
import * as tableHeader from '../../Moecules/TableHeader/AplicantHeader';
import statusicon from '../../../assets/Imagess/status.svg';
import sendEmailICon from '../../../assets/Imagess/email.svg';
import {
  useExportApplicantsTable,
  useFetchPostApplicantData,
  useFetchPostInterestedData,
} from '../../../Hooks/Applicant';
import { useExportShowingInterestTable } from '../../../Hooks/Interested';
import { useNavigate } from 'react-router-dom';
import TableComponent from '../../Moecules/TableComponent/TableComponent';
import ColoredButton from '../../Atoms/Buttons/ColoredButtons/ColoredButton';
import ColumnVisibility from '../../Moecules/TableTopHeader/ColumnVisibility';
import ApplicantGroupTab from '../../Atoms/Tabs/ApplicantGroupTab';
import SelectedNumberComponent from '../../Moecules/TableTopHeader/SelectedNumberComponent';
import automaticAssign from '../../../assets/Imagess/Users/UsersAssignment/automaticAssign.svg';
import AssignModal from '../../Moecules/UsersAssignment/AssignModal';
import TableFilter from '../../Moecules/Custom/TableFilter/TableFilter';
import PrintComponent from '../../Moecules/Custom/ExportComponent/PrintComponent';
import { useReactToPrint } from 'react-to-print';
import { useSearchFilterContext } from '../../../Context/SearchFilterContext';
import { useApplicantContext } from '../../../Context/ApplicantContext';
import { visibleColumnData } from './factory/VisibleColumnData';
import Tooltip from '../../Atoms/Tooltip/Tooltip';
import redQuestionIcon from '../../../assets/Imagess/redQuestionIcon.svg';
import VerificationModal from '../../Moecules/Settings/SettingsModal/VerificationModal';

const Child = ({ flag, setFlag }) => {
  const navigate = useNavigate();
  const printRef = useRef();

  const { filterState, updateFilterState, resetFilterState } =
    useSearchFilterContext();
  const {
    searchValue,
    orderByValue,
    orderDirValue,
    page,
    pageSize,
    filteredColumn,
    isFilter,
    filteredByField,
  } = filterState;
  const [visibleColumn, setVisibleColumn] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('applicantVisibleColumns'));
      if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
        return saved;
      }
    } catch {
      // Fall back to the existing preferences if storage is invalid.
    }
    return filterState.visibleColumn || visibleColumnData;
  });

  useEffect(() => {
    localStorage.setItem('applicantVisibleColumns', JSON.stringify(visibleColumn));
  }, [visibleColumn]);
  const { isApplicant, setIsApplicant } = useApplicantContext();

  const [isAssignUser, setIsAssignUser] = useState({
    isAssigned: false,
    assignTitle: 'Bulk Assign',
  });
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const finalVisibleColumn =
    visibleColumn && Object.keys(visibleColumn).length > 0
      ? visibleColumn
      : visibleColumnData;

  const {
    data: applicants,
    refetch: refetchApplicants,
    isLoading: isApplicantLoading,
  } = useFetchPostApplicantData({
    pageSize: pageSize,
    pageNumber: page,
    searchBy: searchValue,
    desc: orderDirValue == 'desc' ? false : true,
    sortBy: orderByValue || 'CreatedOn',
    selected: isApplicant,
    filterColumns: filteredColumn,
  });

  const {
    data: interested,
    refetch: refetchInterested,
    isLoading: isInterestedLoading,
  } = useFetchPostInterestedData({
    pageSize: pageSize,
    pageNumber: page,
    searchBy: searchValue,
    desc: orderDirValue == 'desc' ? false : true,
    sortBy: orderByValue || 'DateApplied',
    selected: !isApplicant,
    filterColumns: filteredColumn,
  });

  const handleNavigateToSinglePage = (e, id) => {
    e.preventDefault();

    {
      isApplicant
        ? navigate(`/home/applicants/${id}`, {
            state: {
              isApplicant: isApplicant ? true : false,
              query: {
                search: searchValue,
                orderBy: orderByValue,
                orderDir: orderDirValue,
              },
            },
          })
        : navigate(`/home/interested/${id}`, {
            state: {
              isApplicant: isApplicant ? true : false,
              query: {
                search: searchValue,
                orderBy: orderByValue,
                orderDir: orderDirValue,
              },
            },
          });
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    if (isApplicant) {
      refetchApplicants();
    } else {
      refetchInterested();
    }
  }, [
    isApplicant,
    orderByValue,
    orderDirValue,
    page,
    pageSize,
    filteredByField,
  ]);

  useEffect(() => {
    // if the flag is true we will reset the filters / it will be true after first render
    // this is to make sure when i change tabs it will reset but when i get back from another page it wont chang
    if (flag === true) {
      resetFilterState();
    } else {
      setFlag(true);
    }
    setSelectedApplicants([]);
  }, [isApplicant]);

  const handleFilterUpdate = (field, value) => {
    updateFilterState(field, value);
    if (
      field === 'searchValue' ||
      field === 'filteredColumn' ||
      field === 'filteredByField' ||
      field === 'orderByValue' ||
      field === 'orderDirValue'
    ) {
      updateFilterState('page', 1);
    }
  };

  //applicant tab
  const applicantTabContainer = [
    // {
    //   text: 'Prospects',
    //   icon: applicanttabIcon,
    //   number: applicants?.data?.totalCount,
    //   value: true,
    // },
    {
      text: 'Leads',
      icon: intresetedtabIcon,
      number: interested?.data?.totalCount,
      value: false,
    },
  ];

  // change status and email buttons when there is a selected applicants
  const additionalButtons = (
    <>
      <div className={`${styles['number']}`}>
        {selectedApplicants?.length !== 0 && (
          <SelectedNumberComponent selected={selectedApplicants?.length} />
        )}
      </div>

      {selectedApplicants?.length !== 0 && (
        <>
          <ColoredButton
            title='Change Status'
            blue
            rounded={true}
            icon={statusicon}
            handleOnClick={() => setShowStatusModal(true)}
          />
          <ColoredButton
            title='Send Email'
            red
            rounded={true}
            icon={sendEmailICon}
            handleOnClick={() => setShowEmailModal(true)}
          />
          <ColoredButton
            title='Assign User'
            unfilled
            rounded={true}
            icon={automaticAssign}
            handleOnClick={() =>
              setIsAssignUser((prev) => ({
                ...prev,
                assignTitle: 'Assign User',
                isAssigned: true,
              }))
            }
          />
        </>
      )}
    </>
  );

  const rightButtons = (
    <>
      <div>
        {isApplicant && applicants?.data?.totalCount > 999
          ? `${applicants?.data?.totalCount} prospect users`
          : !isApplicant && interested?.data?.totalCount > 999
            ? `${interested?.data?.totalCount} lead users`
            : null}
      </div>

      <ColumnVisibility
        tableHeader={
          isApplicant ? tableHeader.prospectHeader : tableHeader.leadTableHeader
        }
        visibleColumn={finalVisibleColumn}
        setVisibleColumn={setVisibleColumn}
      />

      <TableFilter
        isFilter={isFilter}
        setIsFilter={(value) => handleFilterUpdate('isFilter', value)}
        setFilterByField={(value) =>
          handleFilterUpdate('filteredByField', value)
        }
        setFilteredColumn={(value) =>
          handleFilterUpdate('filteredColumn', value)
        }
      />
    </>
  );

  const rightTableIcon = (item) => (
    <Tooltip content='Verification'>
      <img
        src={redQuestionIcon}
        alt='verification'
        onClick={(e) => (
          setShowVerification((prev) => !prev),
          e.stopPropagation(),
          setSelectedItem(item)
        )}
      />
    </Tooltip>
  );

  //table data that includes data refetch isloading and tableheader
  const tableData = isApplicant
    ? {
        data: {
          ...applicants?.data,
          items: applicants?.data?.items.map((item) => ({
            ...item,
            id: item.applicantId,
            foreignId: item.applicationId,
          })),
        },
        refetch: refetchApplicants,
        isLoading: isApplicantLoading,
        tableHeader: tableHeader.prospectHeader,
      }
    : {
        data: {
          ...interested?.data,
          items: interested?.data?.items.map((item) => ({
            ...item,
            id: item.studentId,
          })),
        },
        refetch: refetchInterested,
        isLoading: isInterestedLoading,
        tableHeader: tableHeader.leadTableHeader,
      };

  return (
    <>
      <WrappingContainer>
        <div>
          <div className={styles['tab-container']}>
            <ApplicantGroupTab
              tabContainer={applicantTabContainer}
              selected={isApplicant}
              setSelected={setIsApplicant}
            />
          </div>
          <div className={styles['table-container']}>
            <TableTopHeader
              isSearch
              search={searchValue}
              setSearch={(value) => handleFilterUpdate('searchValue', value)}
              rightButtons={rightButtons}
              additionalButtons={additionalButtons}
              handlePrint={handlePrint}
              exportData={{
                api: isApplicant
                  ? '/api/ApplicantView/GetApplicants'
                  : '/api/ApplicantView/GetShowingInterest',
                payload: {
                  pageSize: isApplicant
                    ? applicants?.data?.totalCount
                    : interested?.data?.totalCount,
                  pageNumber: 1,
                  searchBy: searchValue,
                  desc: orderDirValue == 'desc' ? false : true,
                  sortBy:
                    orderByValue || (isApplicant ? 'CreatedOn' : 'DateApplied'),
                  selected: isApplicant,
                  filterColumns: filteredColumn,
                },
                visibleColumn: visibleColumn,
                tableHeader: isApplicant
                  ? tableHeader.prospectHeader
                  : tableHeader.leadTableHeader,
                fileName: isApplicant ? 'ApplicantsExport' : 'LeadsExport',
              }}
            />
            <PrintComponent
              ref={printRef}
              title={isApplicant ? 'Prospects Table' : 'Leads Table'}
            >
              <TableComponent
                tableData={tableData}
                setSelected={setSelectedApplicants}
                selected={selectedApplicants}
                page={page}
                setPage={(value) => handleFilterUpdate('page', value)}
                pageSize={pageSize}
                setPageSize={(value) => handleFilterUpdate('pageSize', value)}
                setOrderBy={(value) =>
                  handleFilterUpdate('orderByValue', value)
                }
                setOrderDir={(value) =>
                  handleFilterUpdate('orderDirValue', value)
                }
                orderDir={orderDirValue}
                orderBy={orderByValue}
                setFilterByField={(value) =>
                  handleFilterUpdate('filteredByField', value)
                }
                filteredByField={filteredByField}
                visibleColumn={finalVisibleColumn}
                handleRowClick={handleNavigateToSinglePage}
                checkBox={true}
                pagination={true}
                columnVisibility={true}
                isFilter={isFilter}
                isOrder
                setFilteredColumn={(value) =>
                  handleFilterUpdate('filteredColumn', value)
                }
                rightTableIcon={rightTableIcon}
                isResize
              />
            </PrintComponent>
          </div>
        </div>
      </WrappingContainer>
      {showStatusModal && (
        <StatusModal
          handleOnClose={() => setShowStatusModal(false)}
          title='Change Status'
          isApplicant={isApplicant ? true : false}
          selected={selectedApplicants}
          setSelected={setSelectedApplicants}
          refetch={isApplicant ? refetchApplicants : refetchInterested}
        />
      )}
      {showEmailModal && (
        <EmailModal
          handleOnClose={() => setShowEmailModal(false)}
          title='Send Email'
          selectedApplicants={selectedApplicants}
          setSelectedApplicants={setSelectedApplicants}
          refetchData={isApplicant ? refetchApplicants : refetchInterested}
          isApplicant={isApplicant}
        />
      )}
      {isAssignUser.isAssigned && (
        <AssignModal
          handleOnClose={() =>
            setIsAssignUser((prev) => ({ ...prev, isAssigned: false }))
          }
          selected={selectedApplicants}
          setSelected={setSelectedApplicants}
          title={isAssignUser.assignTitle}
          refetch={isApplicant ? refetchApplicants : refetchInterested}
        />
      )}

      {showVerification && (
        <VerificationModal
          handleOnClose={() => (
            setShowVerification(false),
            setSelectedItem({})
          )}
          setSelectedItem={setSelectedItem}
          selectedItem={selectedItem}
          isApplicant={isApplicant}
          refetch={isApplicant ? refetchApplicants : refetchInterested}
        />
      )}
    </>
  );
};

const AplicantsPage = () => {
  const [flag, setFlag] = useState(false);
  return <Child flag={flag} setFlag={setFlag} />;
};

export default AplicantsPage;
